import React, { FC } from "react";
import { SessionItem, SessionRenderingContext } from "@/mds/components/sessions/session-item";
import { SessionItemFadeInAnimation } from "@/mds/components/sessions/session-item/session-item-fade-in-animation";
import { SessionItemContent } from "@/mds/components/sessions/session-item/session-item-content";

interface Props {
  data: SessionItem;
  context: SessionRenderingContext;
}

export const SessionItemRenderer: FC<Props> = ({ data: item, context }) => {
  return (
    <SessionItemFadeInAnimation key={item.id}>
      <SessionItemContent item={item} context={context} />
    </SessionItemFadeInAnimation>
  );
};
